import styled from "@emotion/styled";
import { ThemeMode } from "@smartsheet/sds-theme-internal";
import { sizes } from "../../../constants/spacing";
import { modalTheme } from "./modalTheme";

export interface StyledModalActionsProps {
    themeMode: ThemeMode;
}

export const StyledModalActions = styled("div")<StyledModalActionsProps>(
    ({ themeMode }) => `
    padding: ${modalTheme.actionsPadding(themeMode)}};
    display: inline-flex;
    align-items: center;
    gap: ${sizes.xSmall}px;
`
);
